import { UserActionTypes } from './user.types';

// functions that return objects

// always align your action type with the type your reducer is expecting
// the type is a string -- use SNAKE_CASE
export const setCurrentUser = user => ({
    type: UserActionTypes.SET_CURRENT_USER,
    payload: user
});